/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Unsupported migration warning code
 */
export type LegacyAuthResponseOrganizationsItemUnsupportedItemCode = typeof LegacyAuthResponseOrganizationsItemUnsupportedItemCode[keyof typeof LegacyAuthResponseOrganizationsItemUnsupportedItemCode];


export const LegacyAuthResponseOrganizationsItemUnsupportedItemCode = {
  fiscalization_series: 'fiscalization_series',
  accounting_categories: 'accounting_categories',
  inventory_and_pricing: 'inventory_and_pricing',
  sales_integrations: 'sales_integrations',
  webhooks: 'webhooks',
} as const;
